"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandHistory = exports.CommandHistoryItem = exports.CommandSent = exports.SendCommandPayload = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
exports.SendCommandPayload = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
    command: effect_1.Schema.NonEmptyString,
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(1)), { exact: true }),
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    deferrable: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'When true, sends the command as an on-demand command job instead of a direct method call. ' +
            'Does not check the caller has permission to operate the device.',
    }),
    params: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
    delivery: effect_1.Schema.optionalWith(effect_1.Schema.Literal('auto', 'job', 'instant'), { exact: true }).annotations({
        description: 'Validated but ignored; delivery mode is always instant unless deferrable is true.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.SendCommandPayload`,
    description: 'deviceId is not a valid alias for serialNumber, despite the legacy JSDoc.',
});
exports.CommandSent = effect_1.Schema.Struct({ requestId: effect_1.Schema.String }).annotations({
    identifier: `${NAMESPACE}.CommandSent`,
    description: 'The device response itself is not returned, only recorded in the command history.',
});
exports.CommandHistoryItem = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    success: effect_1.Schema.Boolean,
    type: effect_1.Schema.String,
    appId: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
    appName: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Looked up from appId. A record with an unknown appId currently answers 500.',
    }),
    userId: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
    deviceId: effect_1.Schema.NonEmptyString,
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int), { exact: true }),
    command: effect_1.Schema.String,
    params: effect_1.Schema.NullOr(Json.Record),
    deferrable: effect_1.Schema.Boolean,
    result: effect_1.Schema.NullOr(Json.Value),
    createdAt: effect_1.Schema.String,
    updatedAt: effect_1.Schema.String,
}).annotations({
    identifier: `${NAMESPACE}.CommandHistoryItem`,
});
exports.CommandHistory = effect_1.Schema.Struct({ items: effect_1.Schema.Array(exports.CommandHistoryItem) }).annotations({
    identifier: `${NAMESPACE}.CommandHistory`,
    description: '90-day window, no pagination. Does not check the caller has permission to operate the device.',
});
//# sourceMappingURL=schema.js.map